export const isCompleted = (loadedTasbeeh) => {
    if (!loadedTasbeeh) return false;
    return loadedTasbeeh.currentCount >= loadedTasbeeh.target
};